module.exports = __webpack_public_path__ + "static/media/part-18.c4da5d71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-18.jpg
// module id = 951
// module chunks = 0